import { ESimTable } from './Inventory/ESimTable';

import { TableLayout } from 'common/components/Layouts/TableLayout/TableLayout';

import { useTabNavigationSetter } from 'src/common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter';
import { productNavigationAtom } from 'src/atoms/pages/pages';
import { useESimProductUrlFromFilters } from './hooks/useESimUrlFromFilters';
import { ProductsTabs } from 'src/products/layout/ProductsTabs';
import { styled } from '@mui/material/styles';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { ErrorFallbackRoot } from 'src/common/components/Fallbacks/ErrorFallback';
import { PageWithGraphs } from 'src/common/components/Layouts/PageLayout/PageWithGraphs';
import { TabsLayoutTabContent } from 'src/common/components/Layouts/TabsLayout/TabsLayout';
import { ESimFilters } from './Inventory/Filters/ESimFilters';
import { ESimFiltersURLParser } from './Inventory/Filters/SearchParams/ESimFilterURLParser';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';

const ESimPageLayoutTabs = styled('div', { name: 'RSimPageLayout' })(({ theme }) => ({
  height: '100%',
  [`& ${TabsLayoutTabContent}`]: {
    border: 'none',
  },
  [`& ${ErrorFallbackRoot}`]: {
    border: `1px solid ${theme.palette.border}`,
    borderRadius: DEFAULT_BORDER_RADIUS,
  },
}));

export const ESimInventoryTab = () => {
  const url = useESimProductUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: productNavigationAtom, routeToSet: url });

  return (
    <PageWithGraphs>
      <ESimPageLayoutTabs>
        <ProductsTabs>
          <TabPanelWithErrorHandling name={'eSIM'}>
            <TableLayout showBorder>
              <ESimFilters />
              <ESimTable />
            </TableLayout>
          </TabPanelWithErrorHandling>
        </ProductsTabs>
      </ESimPageLayoutTabs>
    </PageWithGraphs>
  );
};

export const ESimInventory = () => {
  return (
    <ESimFiltersURLParser>
      <ESimInventoryTab />
    </ESimFiltersURLParser>
  );
};
